import * as message from './message'
import * as integral from './integral'
import * as danmu from './danmu'
import * as account from './account'
import * as agreement from './agreement'

export default {
  message,
  integral,
  account,
  agreement,
  danmu
}
